module.exports = "<div class=\"dashboard\">\r\n    <app-program-card *ngFor=\"let program of mockData\" [program]=\"program\"></app-program-card>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main